import { createButtonFromLibrary } from 'client/components/core/Sidebar/components/Toolbox/creators/create-button'
import { LibraryElementEnum } from 'client/enums/LibraryElementEnum'
import createLibraryElementStructure from 'client/utils/createLibraryElements'
import {
  createDefaultEntityStructure,
  createDefaultEntityStructureNew,
  createMenuFromLibrary,
} from 'client/utils/createStructureUtils'
import { OldEntityWithChildIds } from 'common/types/entities/OldEntityInterface'
import { EntitiesStructure } from 'common/types/Page'
import { BaseEntityWithChildIdsInterface } from 'src/shared/schemas/base-entity.schema'
import { CommonLibraryElementsCreator } from './common-library-elements-creator'

function hasMethod<T, K extends PropertyKey>(
  obj: T,
  method: K,
): obj is T & Record<K, (...args: unknown[]) => EntitiesStructure> {
  return typeof (obj as Record<K, unknown>)[method] === 'function'
}

export type CreatorArgs = {
  container: OldEntityWithChildIds | BaseEntityWithChildIdsInterface
  locale: string
  position: number
}

// NOTE: This class is used for extending the common library elements structures creators in the specific library elements structures creators
// DON'T USE THIS CLASS DIRECTLY, use the specific library elements structures creators instead
// (e.g. WebsiteLibraryElementsStructuresCreator, PageLibraryElementsStructuresCreator)
export class CommonLibraryElementsStructuresCreator {
  constructor(createElement = CommonLibraryElementsCreator) {
    this.createElement = new createElement()
  }
  protected createElement: CommonLibraryElementsCreator

  protected [LibraryElementEnum.LibraryButton](args: CreatorArgs) {
    return createButtonFromLibrary({
      createButton: this.createElement[LibraryElementEnum.LibraryButton],
      ...args,
    })
  }
  protected [LibraryElementEnum.LibraryField](args: CreatorArgs) {
    return createDefaultEntityStructure({
      createEntity: this.createElement[LibraryElementEnum.LibraryField],
      ...args,
    })
  }
  protected [LibraryElementEnum.LibraryForm](args: CreatorArgs) {
    return createDefaultEntityStructureNew({
      createEntity: this.createElement[LibraryElementEnum.LibraryForm],
      ...args,
    })
  }
  protected [LibraryElementEnum.LibraryMenu](args: CreatorArgs) {
    return createMenuFromLibrary({
      createMenu: this.createElement[LibraryElementEnum.LibraryMenu],
      ...args,
    })
  }
  public create = ({
    libraryElementType,
    ...args
  }: { libraryElementType: LibraryElementEnum } & CreatorArgs) => {
    if (hasMethod(this, libraryElementType)) {
      return this[libraryElementType](args)
    } else {
      return createLibraryElementStructure({
        libraryElementType,
        ...args,
      })
    }
  }
}
